import { DataProvider } from '../providers/DataProvider';
import { ControlProvider } from '../providers/ControlProvider';
import { ReactNode } from 'react';
import { RouteProvider } from '../providers/RouteProvider';

const PageWrapper = ({
	children,
	page
}: {
	children: ReactNode;
	page?: string;
}) => {
	return (
		<ControlProvider>
			<RouteProvider>
				<DataProvider page={page}>{children}</DataProvider>
			</RouteProvider>
		</ControlProvider>
	);
};

export default PageWrapper;
